import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardService } from 'src/app/features/events/services/dashboard.service';
import { OutletBackgroundService } from '../../services/outlet-background.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-username.outlet',
  templateUrl: './username.outlet.component.html',
  styleUrls: ['./username.outlet.component.css'],
  providers: [DashboardService],
})
export class UsernameOutletComponent implements OnInit, OnDestroy {
  bgUrl = '';
  private subscription: Subscription = new Subscription();

  constructor(private outletBackgroundService: OutletBackgroundService) {}

  ngOnInit() {
    this.subscription = this.outletBackgroundService.backgroundImage$.subscribe(
      (imageUrl) => {
        if (imageUrl) {
          this.updateBackground(imageUrl);
        } else {
          this.updateBackground(this.bgUrl);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private updateBackground(imageUrl: string): void {
    const outletElement = document.querySelector('.gigantes-bg-layout');
    if (outletElement) {
      const element = outletElement as HTMLElement;
      element.style.setProperty('--gigantes-bg-image', `url('${imageUrl}')`);
    }
  }
}
